module.exports = __webpack_public_path__ + "static/media/foodprint_app7_preview.4d75bdfb.jpg";